// extracted by mini-css-extract-plugin
export default {"header":"header-XIe1L","body":"body-vOS9E","firstColumn":"firstColumn-gXYWD","tests":"tests-HiBaL"};